/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for uploading a lecturer supervisor presence photo at briefing entry.
 */
export interface OralExamUploadSupervisorPhotoRequest {
  imageBase64: string;
  saveAsProfile?: boolean;
}
